import { PALETTE } from '../../../constants';

export default {
  root: {
    backgroundColor: PALETTE.successColor,
  },
  text: {
    textAlign: 'center',
  },
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  popupTitle: {
    display: 'block',
    paddingLeft: 8,
  },
  popupBody: {
    display: 'block',
    marginTop: 6,
    paddingLeft: 8,
  },
};